import $ from 'jquery';

$(document).ready(() => {
  let winWidth = $(window).outerWidth();
  window.onresize = () => {
    winWidth = $(window).outerWidth();
  };

  const $sideNavLink = $('.js-scroll-link');

  $sideNavLink.on('click', (event) => {
    const $this = $(event.currentTarget);
    event.preventDefault();
    const selectedLink = $this.data('link');
    let offsetHeight = 100;

    if (winWidth < 768) {
      offsetHeight = 150;
    }
    $('html,body')
      .animate({ scrollTop: $(`#${selectedLink}`).offset().top - offsetHeight }, 'slow');
  });
});
